import { BellIcon } from 'lucide-react'

import { ScheduledAlertsCard } from '@/pages/client-portal/ui/cards/scheduled-alerts-card/scheduled-alerts-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { type ClientPortalCaseAlertItem } from '@/lib/queries/case-dashboard/types'
import { cn } from '@/lib/utils'

export interface OtherCriticalDatesPublicProps {
  scheduledAlertsData?: ClientPortalCaseAlertItem[]
}

export const OtherCriticalDatesPublic = ({ scheduledAlertsData }: OtherCriticalDatesPublicProps) => {
  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<BellIcon size={24} />} title="Other Critical Dates" />

      <div className={cn('mt-5')}>
        <div className={cn('lg:max-w-[400px]')}>
          <ScheduledAlertsCard scheduledAlertsData={scheduledAlertsData} />
        </div>
      </div>
    </div>
  )
}
